import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Logo from "@/components/brand/Logo";
import { toast } from "sonner";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("demo@trendrise.ai");
  const [password, setPassword] = useState("Demo!1234");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name.split(" ")[0]}.`);
      navigate(u.onboarding_completed ? "/dashboard" : "/onboarding");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dark-marketing grain min-h-screen flex items-center justify-center px-6" data-testid="login-page">
      <div className="absolute top-6 left-6">
        <Link to="/"><Logo variant="light" /></Link>
      </div>
      <div className="w-full max-w-md glass rounded-sm p-8">
        <p className="editorial-overline">Welcome back</p>
        <h1 className="font-serif text-3xl text-ivory-50 mt-3">Sign in to TrendRise AI</h1>
        <form onSubmit={submit} className="mt-7 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-ivory-200/60">Email</label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-2 w-full bg-transparent border border-ivory-200/20 px-4 py-3 text-ivory-50 rounded-sm focus:border-gold-500 outline-none"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-ivory-200/60">Password</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-2 w-full bg-transparent border border-ivory-200/20 px-4 py-3 text-ivory-50 rounded-sm focus:border-gold-500 outline-none"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full bg-gold-500 hover:bg-gold-400 disabled:opacity-50 text-navy-900 font-semibold rounded-sm py-3 mt-2 transition-colors"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="text-xs text-ivory-200/60 mt-6">
          New to TrendRise AI?{" "}
          <Link to="/signup" className="text-gold-500 hover:text-gold-400" data-testid="login-to-signup">
            Create an account
          </Link>
        </p>
        <p className="text-xs text-ivory-200/60 mt-2">
          <Link to="/forgot-password" className="text-gold-500 hover:text-gold-400" data-testid="login-forgot">
            Forgot your password?
          </Link>
        </p>
        <div className="mt-6 border-t border-ivory-200/10 pt-5">
          <p className="text-[11px] uppercase tracking-widest text-ivory-200/50 mb-2">Demo credentials</p>
          <p className="text-xs text-ivory-200/70 font-mono">demo@trendrise.ai · Demo!1234</p>
          <p className="text-xs text-ivory-200/70 font-mono">admin@trendrise.ai · Admin!1234</p>
        </div>
      </div>
    </div>
  );
}
